import {  writable, get } from 'svelte/store';
import { CollectionORM, API } from './api.js';

let MentorshipRoles = ['1267706698236297298','1267892183999184926','901654202009391125'];
let AcademyRoles = ['1267892183999184926','1267706698236297298','975514144902103100'];
let DailyPOIRoles = ["1267914909459419147","1267915058202021929"];
let WeeklyOutlookRoles = ["1267915058202021929","1267914978199867582"];

export const authToken = writable(localStorage.getItem('auth_token'));

export const Series = CollectionORM(API.service('series/:cuid'), [], 'cuid')
export const Members = CollectionORM(API.service('members/:type'), [], 'cuid')

export const ReportCards = CollectionORM(API.service('report-cards/:cuid'), [], 'cuid');

export const Announcements = CollectionORM(API.service('announcements/:cuid'), [], 'cuid');
export const MentorshipComments = CollectionORM(API.service('mentorship_comments'), [], 'cuid');


export const Topic = CollectionORM(API.service('topics/:cuid'), {loaded:false}, 'cuid',{
  markComplete:function(data){
    return API.service('topics/:cuid/mark_complete').post(data);
  },
  saveNote:function(data){
    return API.service('topics/:cuid/save_note/').post(data);
  },
  updateNote:function(data){
    return API.service('topics/:cuid/update_note/').post(data);
  },
  removeNote:function(data){
    return API.service('topics/:cuid/remove_note').post(data);
  }
});


export const Affiliates = CollectionORM(API.service('resources/:cuid'), [] , 'cuid');

export const ContentCategories = CollectionORM(API.service('content_categories'), [] , 'cuid');

export const MentorshipContentList = CollectionORM(API.service('mentorship/:cuid'), { loaded:false } , 'cuid', {
  toggleFavorite:function(item){
    return API.service('mentorship/:cuid/favorite').post({
      favorite:!item.favorite,
      cuid:item.cuid
    });
  }
});

export const WeeklyOutlookContent = CollectionORM(API.service('weeklyoutlook'), { loaded:false } , 'cuid' );

export const MentorshipContent = CollectionORM(API.service('mentorship/:cuid'), { loaded:false } , 'cuid', {
  toggleFavorite:function(item){
    return API.service('mentorship/:cuid/favorite').post({
      favorite:!item.favorite,
      cuid:item.cuid
    });
  },
  addComment:function(data){
    return API.service('mentorship/:cuid/add_comment').post(data);
  },
  removeComment:function(data){
    return API.service('mentorship/:cuid/comments/:comment').delete(data);
  },
  markComplete:function(data){
    return API.service('mentorship/:cuid/mark_complete').post(data);
  },
  saveNote:function(data){
    return API.service('mentorship/:cuid/save_note/').post(data);
  },
  updateNote:function(data){
    return API.service('mentorship/:cuid/update_note/').post(data);
  },
  removeNote:function(data){
    return API.service('mentorship/:cuid/remove_note').post(data);
  }
});
export const OnetoOneBookings = CollectionORM(API.service('calendly/mybookings/:cuid'), [] , 'cuid');
export const AccountabilitySessions = CollectionORM(API.service('accountability/mybookings'), [] , 'cuid');

// --- Journal APIS
export const Journal = CollectionORM(API.service('journals/:cuid'), [] , 'cuid', {
  trades: function(cuid){
    return this.service.get({cuid},'journals/:cuid/trades')
  }
});

export const UserTradingStats = CollectionORM(API.service('journals/:cuid/stats'), [] , 'cuid');

export let JournalTrades = CollectionORM(API.service('journals/:cuid/trades'), null , 'cuid');
export let TradeDetails = CollectionORM(API.service('trades/:cuid'), null , 'cuid');
export let TradeImages = API.service('trade-images');
export let TradeSetups = CollectionORM(API.service('tradesetups/:cuid'), null , 'cuid', {
  'init':function() {
    return API.service('tradesetups/init').post()
  }
});
export let TradeTags = CollectionORM(API.service('tradetags/:cuid'), null , 'cuid', {
  'init':function() {
    return API.service('tradetags/init').post()
  }
});
export let UserJournalNotes = CollectionORM(API.service('notes/:cuid'), [] , 'cuid');


// ----

export const MyPurchases = CollectionORM(API.service('purchases'), [] , 'cuid');

export const Notes = CollectionORM(API.service('series/:cuid/notes'), {loaded:false}, 'cuid')

export const SeriesCategories = CollectionORM(API.service('series/:cuid/videos_by_category'), [], 'cuid')

export const ActionPlans = CollectionORM(API.service('user/action-plans'), [], 'cuid')

export const User = CollectionORM(API.service('discord-oauth/user', false), null, 'cuid', {
    login: async function(data) {
        return await API.service('/api-token-auth').post(data);
    },
    sendCode: async function(data) {
      let password = API.service('/forgot_password');
      return password.post(data);
    },
    terms: async function(data) {
      let service = API.service('/userterms');
      return service.post(data);
    },
    resetPassword: async function(data) {
      let password = API.service('/reset_password');
      return password.post(data);
    },
    create: async function(data) {
        return await API.service('/create_account').post(data);
    },
    profileImage: async function(data){
      let service = API.service('/user/profile')
      service.contentType("AUTO")
      return await service.post(data);
    },
    hasAccountability: function(){
      let subscriptions = this.getData().subscriptions || [];
      return subscriptions && subscriptions.filter(s => ['1267706698236297298'].indexOf(s.discord_id) != -1).length > 0
    },
    hasMentorship: function(){
      let subscriptions = this.getData().subscriptions || [];
      return subscriptions && subscriptions.filter(s => MentorshipRoles.indexOf(s.discord_id) != -1).length > 0
    },
    hasCouse: function(){
      let subscriptions = this.getData().subscriptions || [];
      return subscriptions && subscriptions.filter(s => AcademyRoles.indexOf(s.discord_id) != -1).length > 0
    },
    hasDailyPOI: function(){
      let subscriptions = this.getData().subscriptions || [];
      return subscriptions && subscriptions.filter(s => DailyPOIRoles.indexOf(s.discord_id) != -1).length > 0
    },
    hasWeeklyOutlook: function(){
      let subscriptions = this.getData().subscriptions || [];
      return subscriptions && subscriptions.filter(s => WeeklyOutlookRoles.indexOf(s.discord_id) != -1).length > 0
    }
});
